var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCraneTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 776 269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "CRANE TRUCK"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-889.778 -6307.48)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(266.222 259.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(591.317 205.51)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.026,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(0 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.313 2.755a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051H71.099a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 2"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": "max. M,M m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(608.33 240.021)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "max. M,M m")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-737.67 -6541)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(421.997 22.763)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "CRANE TRUCK"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17 -12.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M765 85.8v25.4l-17.8 19.4",
    "data-name": "Path 31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m765 111.2 18.7 19.4",
    "data-name": "Line 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M747.2 130.6v13.8a4.225 4.225 0 0 0 4.2 4.2h28a4.225 4.225 0 0 0 4.2-4.2v-13.8h2.3a4.7 4.7 0 0 1 4.7 4.7v59.4a4.7 4.7 0 0 1-4.7 4.7h-41.1a4.7 4.7 0 0 1-4.7-4.7v-59.4a4.7 4.7 0 0 1 4.7-4.7Z",
    "data-name": "Path 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M564.1 207.7h-92a2.326 2.326 0 0 1-2.3-2.3V96.5a2.326 2.326 0 0 1 2.3-2.3h92a2.326 2.326 0 0 1 2.3 2.3v108.9a2.4 2.4 0 0 1-2.3 2.3Z",
    "data-name": "Path 33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M487.7 217.1h-13.2a.9.9 0 0 1-.9-.9v-7.6a.9.9 0 0 1 .9-.9h13.2a.9.9 0 0 1 .9.9v7.6a.9.9 0 0 1-.9.9Z",
    "data-name": "Path 34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M561.8 217.1h-13.2a.9.9 0 0 1-.9-.9v-7.6a.9.9 0 0 1 .9-.9h13.2a.9.9 0 0 1 .9.9v7.6c-.1.5-.4.9-.9.9Z",
    "data-name": "Path 35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M576 137.4h-8.7a.945.945 0 0 1-1-1v-17.5a.945.945 0 0 1 1-1h8.7a.945.945 0 0 1 1 1v17.5a.945.945 0 0 1-1 1Z",
    "data-name": "Path 36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M468.9 137.4h-8.7a.945.945 0 0 1-1-1v-17.5a.945.945 0 0 1 1-1h8.7a.945.945 0 0 1 1 1v17.5a1 1 0 0 1-1 1Z",
    "data-name": "Path 37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M555.6 152.1h-75l-4-16.7v-17.6l18.9 3.4H541l18.6-3.4v17.6Z",
    "data-name": "Path 38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m476.6 187 12.5 6.3-3.9-13.5",
    "data-name": "Path 39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m559.6 187-12.5 6.3 3.9-13.5",
    "data-name": "Path 40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M496 181.5h44.1",
    "data-name": "Line 21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M502.3 191.4h31.5",
    "data-name": "Line 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m297.5 206.6-78 5.6a2.283 2.283 0 0 1-2-2.5v-72.2l-10.1-59.1a2.283 2.283 0 0 1 2-2.5l71.1 6.3c2.9.3 4.3 2.5 5.3 5.8l13.6 51v65.1a2.151 2.151 0 0 1-1.9 2.5Z",
    "data-name": "Path 41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m209.4 75.9-29.3 3.6a7 7 0 0 0-5.4 2.9 5.987 5.987 0 0 0-1.1 3.4l1.8 88.8-9.3 6.4-126.2-4.2a4.127 4.127 0 0 0-4.3 3.9v6.9a4.15 4.15 0 0 0 3.9 4.4l9 1",
    "data-name": "Path 42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 19.9,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 7",
    rx: 12,
    ry: 19.9,
    transform: "translate(181.4 183.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M272.8 209.2c-2.1 6.1-5.4 8.9-9.5 8.9-3.7 0-7-2.8-9.2-7.1",
    "data-name": "Path 43"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.8,
    cy: 16.3,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 8",
    rx: 9.8,
    ry: 16.3,
    transform: "translate(79 181.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M143.3 197.8c-.8 5.4-4.2 9.5-8.3 9.5s-7.5-4.1-8.3-9.5",
    "data-name": "Path 44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M117.3 196.7c-.7 5.1-4 9-7.9 9s-7.1-3.9-7.9-9",
    "data-name": "Path 45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.6,
    cy: 15.9,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 9",
    rx: 9.6,
    ry: 15.9,
    transform: "translate(47.8 180.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m232.8 134.8 49.6.2a3.2 3.2 0 0 0 3.1-2.6l1.3-9.3a3.333 3.333 0 0 0-.2-1.7l-3.6-11.6a3.275 3.275 0 0 0-3-2l-9.9.5-28.9-1.2h-.3l-14.2-1.9a3.063 3.063 0 0 0-3.5 3.3l1.1 11.7a1.689 1.689 0 0 0 .3 1l5.4 11.6a3.165 3.165 0 0 0 2.8 2Z",
    "data-name": "Path 46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m224.3 191.5 17.2 4.3-3.3-14.4",
    "data-name": "Path 47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m292.6 189.5-9.2 3.6 3.9-13.9",
    "data-name": "Path 48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m194.5 98.8 5.8-.2c1.1 0 1.9 1 2 2.4l3.2 21.9c.1 1.6-1.1 2.8-2.3 2.5l-9.3-2.4a2.375 2.375 0 0 1-1.6-2.5l.3-19.4a2.138 2.138 0 0 1 1.9-2.3Z",
    "data-name": "Path 49"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.1,
    cy: 7.1,
    r: 7.1,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 10",
    transform: "translate(206.4 25.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.1,
    cy: 7.1,
    r: 7.1,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 11",
    transform: "translate(157.5 54.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m166.8 54.9 39.8-23.5",
    "data-name": "Line 23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M172.1 62.7 210.7 39",
    "data-name": "Line 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m79.4 194.8-13-.7",
    "data-name": "Line 25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m78.5 203.5-13.1-.7",
    "data-name": "Line 26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m98.2 195.8 69.8 3.8a1.561 1.561 0 0 1 1.5 1.6l.8 4.5a1.71 1.71 0 0 0 1.7 1.8l10.2.8",
    "data-name": "Path 50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m219.5 212.1-15.5-.6",
    "data-name": "Line 27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m248.5 182.9 27.3-1.5",
    "data-name": "Line 28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m251.2 193.1 24-1.4",
    "data-name": "Line 29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.9,
    cy: 7.7,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 12",
    rx: 2.9,
    ry: 7.7,
    transform: "translate(85.9 190)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.7,
    cy: 9.7,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 13",
    rx: 3.7,
    ry: 9.7,
    transform: "translate(189.6 193.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.7,
    cy: 7.2,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 14",
    rx: 2.7,
    ry: 7.2,
    transform: "translate(54.7 189.3)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m219.5 28.8 118.7 40.9a4.437 4.437 0 0 1 3.2 5.5 4.5 4.5 0 0 1-5.3 3.1L218 37",
    "data-name": "Path 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.4 74.6.1 26.2-24.6 19.9",
    "data-name": "Path 52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.5 100.8 25.7 19.9",
    "data-name": "Line 30"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.4 124.1v9.8a3.167 3.167 0 0 1-2.9 3.4h-35.6a3.167 3.167 0 0 1-2.9-3.4v-9.8a3.167 3.167 0 0 0-2.9-3.4h-2.2a3.167 3.167 0 0 0-2.9 3.4v63.2a3.167 3.167 0 0 0 2.9 3.4h51.3a3.167 3.167 0 0 0 2.9-3.4v-63.2a3.167 3.167 0 0 0-2.9-3.4h-1.9a3.167 3.167 0 0 0-2.9 3.4Z",
    "data-name": "Path 53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5 137.3v53.4",
    "data-name": "Line 31"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m166.9 181.1 2.5 19.5",
    "data-name": "Line 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m175.4 174.7-9.3 6.4L40.6 177v-27.1a3.372 3.372 0 0 1 3.4-3.4h130Z",
    "data-name": "Path 54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M203.1 100.3h9.1",
    "data-name": "Line 33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M207.4 120.7h8",
    "data-name": "Line 34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M169.4 66.5v81.8",
    "data-name": "Line 35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M159.8 66.5v81.8",
    "data-name": "Line 36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m214.3 54.9-30.2 3.2 7.8-5.5 22-2.3a2.425 2.425 0 0 1 2.6 2.1 2.49 2.49 0 0 1-2.2 2.5Z",
    "data-name": "Path 55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m216 52.4 36-3.5",
    "data-name": "Line 37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.1,
    cy: 7.1,
    r: 7.1,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 15",
    transform: "translate(559.2 20.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.1,
    cy: 7.1,
    r: 7.1,
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    "data-name": "Ellipse 16",
    transform: "translate(510.3 50.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m519.6 50.1 39.8-23.6",
    "data-name": "Line 38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m524.9 57.9 38.6-23.7",
    "data-name": "Line 39"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m572.3 23.9 192.1 53.8a4.437 4.437 0 0 1 3.2 5.5 4.5 4.5 0 0 1-5.3 3.1L570.8 32.2",
    "data-name": "Path 56"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M522.2 61.7v32.1",
    "data-name": "Line 40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M512.6 61.7v32.1",
    "data-name": "Line 41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m567.1 50.1-30.2 3.2 7.8-5.5 22-2.3a2.425 2.425 0 0 1 2.6 2.1 2.49 2.49 0 0 1-2.2 2.5Z",
    "data-name": "Path 57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "m568.8 47.6 42-4.1",
    "data-name": "Line 42"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M396.5 11.4v192.8",
    "data-name": "Line 43"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m392.1 12.7 4.4-7.7 4.5 7.7Z",
    "data-name": "Path 58"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m392.1 202.8 4.4 7.8 4.5-7.8Z",
    "data-name": "Path 59"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M572.3 202.7h198.2",
    "data-name": "Line 44"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m573.6 207.1-7.8-4.4 7.8-4.5Z",
    "data-name": "Path 60"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m769.1 207.1 7.8-4.4-7.8-4.5Z",
    "data-name": "Path 61"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m6.5 213.4 184.2 12.9",
    "data-name": "Line 45"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M7.4 218 0 213l8.1-4Z",
    "data-name": "Path 62"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m189 230.7 8.1-3.9-7.4-5.1Z",
    "data-name": "Path 63"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m216 225.9 64.1-5.5",
    "data-name": "Line 46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m217.7 230.2-8.1-3.8 7.4-5.1Z",
    "data-name": "Path 64"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m279.2 225 7.3-5.1-8.1-3.9Z",
    "data-name": "Path 65"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(32.968 219.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(0 16.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.504 23.468a2 2 0 0 1 .802-2.204L78.012 9.262a2 2 0 0 1 3 2.344L69.164 44.174a2 2 0 0 1-3.806-.132Z",
    "data-name": "Polygon 2"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(47.528 259.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraneTruck);
export default __webpack_public_path__ + "static/media/CraneTruck.21ad9d041d8c785f56dd2dd2a4a1b217.svg";
export { ForwardRef as ReactComponent };